// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import ReactCSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { cssInJS } from '../../utils/styles';

export default class NavigationController extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    mapVisible: PropTypes.bool.isRequired,
    transitionTimeout: PropTypes.number.isRequired,
    viewClassName: PropTypes.string,
    viewWidth: PropTypes.number.isRequired,
    views: PropTypes.node.isRequired,
  };

  static defaultProps = {
    transitionTimeout: 300,
  };

  // for media queries
  constructor(props, context) {
    super(props, context);

    this.state = {
      matchesSm: window.matchMedia('(max-width: 960px)').matches,
    };
  }

  componentDidMount() {
    const handlerSm = (e) => this.setState({ matchesSm: e.matches });
    window.matchMedia('(max-width: 960px)').addEventListener('change', handlerSm);
  }

  componentWillUnmount() {
    window.matchMedia('(max-width: 960px)').removeEventListener('change', this.handlerSm);
  }
  // END for media queries

  render() {
    const { mapVisible } = this.props;

    const views = this.props.views.map((view, index) => this.renderView(view, index));

    const offset = -(this.props.viewWidth * (this.props.views.length - 1));

    const sliderStyle = {
      transform: `translate3d(${offset}px, 0%, 0px)`,
      transition: `transform ${this.props.transitionTimeout}ms ease`,
      width: 100000,
      top: (mapVisible && this.state.matchesSm) ? 36 : 84,
    };

    const { styles } = NavigationController;

    return (
      <div className={this.props.className}>
        <ReactCSSTransitionGroup
          component="div"
          className={styles.slider}
          style={sliderStyle}
          transitionName="navigation-controller-transition"
          transitionEnterTimeout={this.props.transitionTimeout}
          transitionLeaveTimeout={this.props.transitionTimeout}
        >
          {views}
        </ReactCSSTransitionGroup>
      </div>
    );
  }

  renderView(view, index) {
    const { styles } = NavigationController;

    const props = {
      ...this.props,
      key: index,
      navigationController: this,
    };

    const classes = /* FIX CX */ css('navigation-controller-view',
      styles.view,
      this.props.viewClassName);

    const viewStyle = {
      width: this.props.viewWidth,
    };

    return (
      <div
        className={classes}
        style={viewStyle}
        key={`navigation-controller-${index}`}
      >
        {React.cloneElement(view, props)}
      </div>
    );
  }
}

const styles = cssInJS({
  slider: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'row',
    top: 84,
    bottom: 0,
  },

  view: {
    height: '100%',
    position: 'relative',
  },
});

NavigationController.styles = styles;
